import React, { useState } from 'react';
import PropTypes from "prop-types";
import { Modal, Button, Checkbox  } from 'rhombus-react';

import { noop } from 'utils/common';

import CreativesTable from "widgets/table/CreativesTable";

const videoDisclaimer = "Please Note: You may need to re-encode the video if any creatives use a manually encoded variant of it.";

export default function SingleFileModal(props) {
	const {
		assetType,
		title,
		name,
		creatives,
		canApplyToAll,

		onSkip,
		onRename,
		onOverwrite,
		onCancel,
	} = props;
	const [applyToAll, setApplyToAll] = useState(false);

	let noCreativesError = (
		<p className="error-msg center">
			An asset named <span className="asset-name"><q><b>{name}</b></q></span> already exists in your library. Do you want to overwrite it with the one you are uploading?
		</p>
	);

	function renderTable() {
		return (
			<div className="table-container">
				<p className="error-msg">An asset named <span className="asset-name"><q><b>{name}</b></q></span> already exists in the library and will affect the following creatives. {(assetType === "videos") && videoDisclaimer} <br />Do you want to overwrite it with the one you are uploading?</p>
				<CreativesTable creatives={creatives} />
			</div>
		);
	}

	function renderContent(){
		return (
			<div className={`c-modal-body ${creatives.length ? 'grid' : ''}`}>
				{creatives.length ? renderTable() : noCreativesError}
			</div>
		);
	}

	function renderFooter(){
		return (
			<>
				<Button onClick={onCancel} theme="default">Cancel Upload</Button>
				<div className="actions-container">
					{
						canApplyToAll && (
							<Checkbox
								checked={applyToAll}
								onChange={(e) => { setApplyToAll(e.currentTarget.checked); }}
								label="Apply to All"
							/>
						)
					}
					<Button onClick={() => onSkip(applyToAll)}>Skip</Button>
					<Button onClick={() => onRename(applyToAll)}>Rename</Button>
					<Button onClick={() => onOverwrite(applyToAll)} theme="red">Overwrite Asset</Button>
				</div>
			</>
		);
	}

	let modalProps = {
		type: "modal",
		title,
		allowFullScreen: false,
		className: "upload-error-modal single-file-modal",
		xClose: false,
		bladeProps: {
			verticallyCenter: true,
			initialFocus: "p", /*
				If we don't set initialFocus to something, it will auto focus one of the preview
				links, which the user might open by accident by hitting enter.

				After the user attempts to upload, this modal may pop up while they're in the middle
				of doing something else, so we set a value here that won't actually focus anything.
			*/
		},
		renderContent,
		renderFooter,
	};

	return <Modal {...modalProps} />;
}

SingleFileModal.displayName = "SingleFileModal";

SingleFileModal.propTypes = {
	assetType: PropTypes.oneOf([
		"images",
		"richloads",
		"videos",
		"after-effects",
		// "audios",
	]),
	title: PropTypes.string,
	name: PropTypes.string,
	creatives: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string,
		fileName: PropTypes.string,
		adType: PropTypes.string,
		approval: PropTypes.string,
	})),
	canApplyToAll: PropTypes.bool,

	onSkip: PropTypes.func,
	onRename: PropTypes.func,
	onOverwrite: PropTypes.func,
	onCancel: PropTypes.func,
};

SingleFileModal.defaultProps = {
	title: "Upload Error",
	creatives: [],
	canApplyToAll: true,

	onSkip: noop,
	onRename: noop,
	onOverwrite: noop,
	onCancel: noop,
};
